import ChipsList from 'components/molecules/ChipsList';
import SelectV2 from 'components/atoms/Select';
import {
  SelectDivider,
  SelectWrapper,
} from 'components/molecules/settings/TimeConfigs/styled';
import { InputError } from 'components/atoms/styleds';
import { getDayHourPerHalf, getErrorByKey } from 'utils';

const TimeItem = ({ onSelectTime, item, itemData, error }) => {
  const hours = getDayHourPerHalf();
  return (
    <SelectWrapper>
      <SelectV2
        desktopMb={0}
        mb={0}
        fullWidth={true}
        label='Inizio'
        onChange={onSelectTime}
        name={`time_from-${item.id}`}
        items={hours}
        selectedKey={itemData?.time_from}
        // error={error}
      />
      <SelectDivider>—</SelectDivider>
      <SelectV2
        desktopMb={0}
        mb={0}
        fullWidth={true}
        label='Fine'
        onChange={onSelectTime}
        name={`time_to-${item.id}`}
        items={hours}
        selectedKey={itemData?.time_to}
        // error={error}
      />
    </SelectWrapper>
  );
};

const getFuckingError = (error, index) => {
  if (!error) {
    return null;
  }

  return error.find((i) => {
    const [key] = Object.keys(i);
    return parseInt(key) === parseInt(index);
  });
};

const getDayData = (openingHours = [], dayNumber) => {
  return [...openingHours].find(i => i.dayNumber === dayNumber && !i.day_off);
};

const getFormattedDays = (openingHours) => {
  const result = {};
  openingHours?.forEach(i => {
    result[i.day_number] = i;
  });

  return result;
};

const ServiceWeekTimes = ({ data, onClickChip, onSelectTime, errors }) => {
  const dayError = errors && errors['service_opening_hours.day_number'];
  const formattedDays = getFormattedDays(data.service_opening_hours_attributes);
  const weekDays = [
    {
      id: '0-service',
      title: 'Lunedì',
      additionalContent: !formattedDays[0]?.day_off && (
        <>
          <TimeItem
            onSelectTime={(t) => onSelectTime(t, 0)}
            onSelect={(t) => onSelectTime(t, 0)}
            item={{ id: 0 }}
            itemData={formattedDays[0]}
          />
        </>
      ),
      error: getFuckingError(dayError, 0)?.[0],
    },
    {
      id: '1-service',
      title: 'Martedì',
      additionalContent: !formattedDays[1]?.day_off && (
        <>
          <TimeItem
            onSelectTime={(t) => onSelectTime(t, 1)}
            onSelect={(t) => onSelectTime(t, 1)}
            item={{ id: 1 }}
            itemData={formattedDays[1]}
          />
        </>
      ),
      error: getFuckingError(dayError, 1)?.[1],
    },
    {
      id: '2-service',
      title: 'Mercoledì',
      additionalContent: !formattedDays[2]?.day_off && (
        <>
          <TimeItem
            onSelectTime={(t) => onSelectTime(t, 2)}
            onSelect={(t) => onSelectTime(t, 2)}
            item={{ id: 2 }}
            itemData={formattedDays[2]}
          />
        </>
      ),
      error: getFuckingError(dayError, 2)?.[2],
    },
    {
      id: '3-service',
      title: 'Giovedì',
      additionalContent: !formattedDays[3]?.day_off && (
        <>
          <TimeItem
            onSelectTime={(t) => onSelectTime(t, 3)}
            onSelect={(t) => onSelectTime(t, 3)}
            item={{ id: 3 }}
            itemData={formattedDays[3]}
          />
        </>
      ),
      error: getFuckingError(dayError, 3)?.[3],
    },
    {
      id: '4-service',
      title: 'Venerdì',
      additionalContent: !formattedDays[4]?.day_off && (
        <>
          <TimeItem
            onSelectTime={(t) => onSelectTime(t, 4)}
            onSelect={(t) => onSelectTime(t, 4)}
            item={{ id: 4 }}
            itemData={formattedDays[4]}
          />
        </>
      ),
      error: getFuckingError(dayError, 4)?.[4],
    },
    {
      id: '5-service',
      title: 'Sabato',
      additionalContent: !formattedDays[5]?.day_off && (
        <>
          <TimeItem
            onSelectTime={(t) => onSelectTime(t, 5)}
            onSelect={(t) => onSelectTime(t, 5)}
            item={{ id: 5 }}
            itemData={formattedDays[5]}
          />
        </>
      ),
      error: getFuckingError(dayError, 5)?.[5],
    },
    {
      id: '6-service',
      title: 'Domenica',
      additionalContent: !formattedDays[6]?.day_off && (
        <>
          <TimeItem
            onSelectTime={(t) => onSelectTime(t, 6)}
            onSelect={(t) => onSelectTime(t, 6)}
            item={{ id: 6 }}
            itemData={formattedDays[6]}
          />
        </>
      ),
      error: getFuckingError(dayError, 6)?.[6],
    },
  ];

  const selectedDays = [...(data.service_opening_hours_attributes || [])]
    .filter((i) => !i.day_off)
    .map((i) => `${i.day_number}-service`);

  return (
    <div style={{ position: 'relative' }}>
      <ChipsList
        selectedList={selectedDays}
        isColumn={true}
        onlyNative={true}
        onClick={onClickChip}
        list={weekDays}
      />
    </div>
  );
};

export default ServiceWeekTimes;
